import React from "react";
import DashShell from "@/components/DashShell";
import {
  LayoutDashboard, UserCheck, Building2, Boxes, Briefcase, DollarSign, AlertTriangle,
  Inbox, Flame, Sparkles, Settings, Users,
} from "lucide-react";

const ITEMS = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/exceptions", label: "Exception Queue", icon: AlertTriangle },
  { to: "/admin/agents", label: "Agent Applications", icon: UserCheck },
  { to: "/admin/providers", label: "Providers", icon: Building2 },
  { to: "/admin/capacity", label: "Care Capacity", icon: Boxes },
  { to: "/admin/opportunities", label: "Commission Opps", icon: Briefcase },
  { to: "/admin/commissions", label: "Commissions", icon: DollarSign },
  { to: "/admin/leads", label: "All Leads", icon: Inbox },
  { to: "/admin/prospects", label: "Accelerator Prospects", icon: Flame },
  { to: "/admin/content", label: "Content Factory", icon: Sparkles },
  { to: "/admin/users", label: "Users", icon: Users },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminApp() {
  return <DashShell items={ITEMS} title="Owner / Admin Console" />;
}
